import { GraphQLNonNull, GraphQLInt, GraphQLID, GraphQLString } from 'graphql'
import { libraryUsageOrderType } from './library-usage-order'
import {
  libraryUsageFilterArgType,
  LibraryUsageFilterArg
} from './library-usage-filter-arg'
import { SkeletorTableState } from '@contrast-security-inc/design-system-tables'

export interface LibraryUsagePagingArgs {
  readonly offset: number
  readonly limit: number
  readonly organizationID: string
  readonly applicationID: string
  readonly libraryHash: string
  readonly sortingOrder?: SkeletorTableState['sorting']
  readonly filters?: LibraryUsageFilterArg
}

export const libraryUsagePagingArgs = {
  offset: {
    description: 'The index in the collection to start at',
    type: new GraphQLNonNull(GraphQLInt)
  },
  limit: {
    description: 'The number of items to fetch',
    type: new GraphQLNonNull(GraphQLInt)
  },
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  applicationID: {
    description: 'The unique ID for the application being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  libraryHash: {
    description: 'The unique hash for the library related to the usage items',
    type: new GraphQLNonNull(GraphQLString)
  },
  orderBy: {
    description: 'Options for ordering library usage items',
    type: libraryUsageOrderType
  },
  filters: {
    description: 'Options for filtering library usage items',
    type: libraryUsageFilterArgType
  }
}
